import React from 'react';
import { compact } from 'lodash';
import { Typography, TableList } from 'seagull';
import { Breakdown } from "./types";
export function RevenueBreakdownRow(props) {
  const items = compact([props.showPeriod && {
    value: /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "revenue-breakdown-report-row-day",
      variant: "paragraph1",
      noWrap: true
    }, props.day)
  }, props.breakdowns.includes(Breakdown.Customer) && {
    value: /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "revenue-breakdown-report-row-customer",
      variant: "paragraph1",
      noWrap: true,
      ellipsis: true
    }, props.customer || '')
  }, props.breakdowns.includes(Breakdown.Service) && {
    value: /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "revenue-breakdown-report-row-service",
      variant: "paragraph1",
      noWrap: true,
      ellipsis: true
    }, props.service || '')
  }, {
    value: /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "revenue-breakdown-report-row-revenue",
      variant: "paragraph1",
      noWrap: true
    }, props.revenue)
  }]);
  return /*#__PURE__*/React.createElement(TableList.Row, {
    items: items,
    rowId: props.index,
    "data-testid": "revenue-report-row-".concat(props.index),
    "data-heapid": "revenue-report-row"
  });
}